import { Card as MuiCard, Stack } from '@mui/material';

import CardAction from './CardAction';
import CardBody from './CardBody';
import CardIcon from './CardIcon';
import type { CardProps } from './types';

const Card = ({ title, description, icon, to, actionLabel }: CardProps) => (
  <MuiCard
    elevation={0}
    sx={(theme) => ({
      p: 3,
      height: '100%',
      borderRadius: 2,
      border: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      backgroundColor: theme.palette.mode === 'dark' ? '#2e2d2e' : theme.palette.common.white,
      boxShadow: '0px 2px 8px rgba(46, 45, 46, 0.08)',
    })}
  >
    <Stack spacing={2.5} sx={{ alignItems: 'center', textAlign: 'center' }}>
      <CardIcon icon={icon} />
      <CardBody title={title} description={description} />
    </Stack>

    <CardAction to={to} actionLabel={actionLabel} />
  </MuiCard>
);

export default Card;
export type { CardProps } from './types';
